import { render, staticRenderFns } from "./_delivery.tab.vue?vue&type=template&id=55b46511&scoped=true"
import script from "./_delivery.tab.vue?vue&type=script&lang=js"
export * from "./_delivery.tab.vue?vue&type=script&lang=js"
import style0 from "./_delivery.tab.vue?vue&type=style&index=0&id=55b46511&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b46511",
  null
  
)

export default component.exports